import { useTranslation } from "react-i18next";

export function ModalActions({
  onClose,
  onSave,
  disabled,
  loading,
  hideSave = false,
  saveLabel,
}: {
  onClose: () => void;
  onSave: () => void;
  disabled?: boolean;
  loading?: boolean;
  hideSave?: boolean;
  saveLabel?: string;
}) {
  const { t } = useTranslation(["common"]);

  const activeCloseLabel = hideSave ? t("common:close") : t("common:cancel");
  const activeSaveLabel = saveLabel || t("common:save");

  return (
    // Pinned to the bottom of the dialog's scroll area, so Save stays in reach
    // on a long form. The negative margins undo ModalShell's body padding so
    // the bar spans edge to edge.
    <div
      className="
      sticky -bottom-4 z-10 sm:-bottom-5
      -mx-4 -mb-4 sm:-mx-6 sm:-mb-5
      flex flex-wrap justify-end gap-3
      px-4 py-3 sm:px-6
      border-t border-[rgb(var(--border))]
      bg-[rgb(var(--card))]
    "
    >
      <button
        onClick={onClose}
        // Was carrying border/hover/background twice over, the later copy
        // silently winning — collapsed to one set.
        className="
          rounded-lg px-4 py-2 text-sm
          border border-[rgb(var(--border))]
          bg-[rgb(var(--card))]
          text-[rgb(var(--text-primary))]
          transition-colors
          hover:bg-[rgb(var(--card-muted))]
          focus:outline-none focus-visible:ring-2
          focus-visible:ring-[rgb(var(--text-accent))]
        "
      >
        {activeCloseLabel}
      </button>

      {!hideSave && (
        <button
          onClick={onSave}
          disabled={disabled || loading}
          className="
            rounded-lg px-5 py-2 text-sm font-medium
            bg-[rgb(var(--accent-fill))]
            text-[rgb(var(--accent-ink))] shadow-sm
            transition
            hover:opacity-90
            disabled:opacity-50 disabled:cursor-not-allowed
            focus:outline-none focus-visible:ring-2
            focus-visible:ring-[rgb(var(--text-accent))]
            focus-visible:ring-offset-2
            focus-visible:ring-offset-[rgb(var(--card))]
          "
        >
          {loading ? t("common:actions.saving") : activeSaveLabel}
        </button>
      )}
    </div>
  );
}
